<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 20px">
        <v-container>
          <v-tabs v-model="tab" grow show-arrows v-show="id ? true : false">
            <v-tab :key="0">Dados da Licitação</v-tab>
            <v-tab :key="1">Doação Orcamentária</v-tab>
            <v-tab :key="2">Propostas Ganhadoras</v-tab>
            <v-tab :key="3">Contratos</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item :key="0">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      label="Prefeitura:"
                      :rules="fieldRules"
                      :items="prefectures"
                      item-value="prefecture_id"
                      item-text="prefecture_social_name"
                      v-model="data.prefecture_id"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Numero do Processo:"
                      v-model="data.bidding_process_number"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      label="Tipo de Licitação:"
                      :rules="fieldRules"
                      :items="types"
                      item-value="type_id"
                      item-text="type_desc"
                      v-model="data.type_id"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      label="Modalidade:"
                      :rules="fieldRules"
                      :items="modalities"
                      item-value="modality_id"
                      item-text="modality_desc"
                      v-model="data.modality_id"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Publicação do Edital:"
                      v-model="data.bidding_publication_notice"
                      v-mask-date.br
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Habilitação:"
                      v-model="data.bidding_qualification"
                      v-mask-date.br
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Julgamento das propostas:"
                      v-model="data.bidding_tenders"
                      v-mask-date.br
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Homologação:"
                      v-model="data.bidding_homologation"
                      v-mask-date.br
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Valor R$:"
                      v-model="data.bidding_value"
                      v-mask-decimal.br="2"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field
                      label="Numero das Propostas:"
                      v-model="data.bidding_number_of_proposals"
                      v-mask-number
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Objeto"
                      v-model="data.bidding_object"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-checkbox
                      label="Ativo"
                      v-model="data.bidding_status"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-form>
            </v-tab-item>
            <v-tab-item :key="1">
              <Donations :bidding_id="id" :prefecture_id="data.prefecture_id" />
            </v-tab-item>
            <v-tab-item :key="2">
              <Items :bidding_id="id" />
            </v-tab-item>
            <v-tab-item :key="3">
              <Contracts :bidding_id="id" />
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Donations from "./donnations";
import Items from "./items";
import Contracts from "./contracts";
export default {
  props: ["id"],
  components: {
    Donations,
    Items,
    Contracts,
  },
  data: () => ({
    tab: 0,
    valid: false,
    loader: false,
    prefectures: [],
    modalities: [],
    types: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      modality_id: null,
      prefecture_id: null,
      type_id: null,
      bidding_id: null,
      bidding_process_number: "",
      bidding_publication_notice: "",
      bidding_qualification: "",
      bidding_tenders: "",
      bidding_homologation: "",
      bidding_value: 0,
      bidding_number_of_proposals: 0,
      bidding_object: "",
      bidding_status: false,
    },
  }),
  created() {
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    this.$http
      .get("/biddings/modalities")
      .then((r) => (this.modalities = r.data));
    this.$http.get("/biddings/types").then((r) => (this.types = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`biddings/${this.id}`).then((r) => {
        this.data = r.data[0];
        this.data.bidding_homologation = this.convertDate(
          this.data.bidding_homologation
        );
        this.data.bidding_tenders = this.convertDate(this.data.bidding_tenders);
        this.data.bidding_qualification = this.convertDate(
          this.data.bidding_qualification
        );
        this.data.bidding_publication_notice = this.convertDate(
          this.data.bidding_publication_notice
        );
        this.data.bidding_value = this.data.bidding_value.toFixed(2);

        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    convertDate(v) {
      if (v) {
        v = v.replace("-", "").replace("-", "");
        let year = v.substring(0, 4);
        let month = v.substring(4, 6);
        let day = v.substring(6, 8);
        return `${day}/${month}/${year}`;
      } else {
        return false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/biddings/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/biddings-manager");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/biddings", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push("/biddings-manager");
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>